<template>
    <div>
        <b-button class="mr-1 mb-3 right" variant="primary" @click="isModalOpen=true">
            bezahl.de
        </b-button>

        <div class="clear"/>

        <b-modal id="cost-unit-payment-request-modal" v-model="isModalOpen" hide-footer no-close-on-backdrop size="xl"
            title="Zahlungsaufforderungen" @hide="reset()" @show="loadPaymentRequestData">
            <div v-if="isLoading" class="d-flex justify-content-center">
                <csp-loading-indicator/>
            </div>
            <b-row v-else>
                <div v-if="customerExists" class="col">
                    <csp-payment-request-recipient
                        :files="paymentRequestData.files.data"
                        :payment-request-data="paymentRequestData.customerPaymentRequests.data.attributes"
                        recipient="customer"
                        :record-id="recordId"
                        @payment-request-sent="loadPaymentRequestData; $emit('payment-request-sent')"/>
                </div>
                <div v-if="lawyerExists" class="col">
                    <csp-payment-request-recipient
                        :files="paymentRequestData.files.data"
                        :payment-request-data="paymentRequestData.lawyerPaymentRequests.data.attributes"
                        recipient="lawyer"
                        :record-id="recordId"
                        @payment-request-sent="loadPaymentRequestData; $emit('payment-request-sent')"/>
                </div>
                <div v-if="insuranceExists" class="col">
                    <csp-payment-request-recipient
                        :files="paymentRequestData.files.data"
                        :payment-request-data="paymentRequestData.insurancePaymentRequests.data.attributes"
                        recipient="insurance"
                        :record-id="recordId"
                        @payment-request-sent="loadPaymentRequestData; $emit('payment-request-sent')"/>
                </div>
            </b-row>
        </b-modal>
    </div>
</template>

<script>
    import Container from '@services/Container';
    import PaymentRequestRecipient from '@desktop/components/record/cost-unit/PaymentRequestRecipient.vue';

    const container = Container.getInstance();
    const recordRepository = container.getDesktopRecordRepository();

    export default {
        name: 'PaymentRequestModal',
        components: {
            'csp-payment-request-recipient': PaymentRequestRecipient,
        },
        props: {
            recordId: {
                type: Number,
                required: true,
            },
        },
        emits: ['payment-request-sent'],
        data() {
            return {
                isLoading: true,
                isModalOpen: false,
                paymentRequestData: {},
            }
        },
        computed: {
            customerExists() {
                return this.paymentRequestData.customerPaymentRequests
                    && this.paymentRequestData.customerPaymentRequests.data
                    && this.paymentRequestData.customerPaymentRequests.data.attributes
            },
            lawyerExists() {
                return this.paymentRequestData.lawyerPaymentRequests
                    && this.paymentRequestData.lawyerPaymentRequests.data
                    && this.paymentRequestData.lawyerPaymentRequests.data.attributes
            },
            insuranceExists() {
                return this.paymentRequestData.insurancePaymentRequests
                    && this.paymentRequestData.insurancePaymentRequests.data
                    && this.paymentRequestData.insurancePaymentRequests.data.attributes
            },
        },
        methods: {
            loadPaymentRequestData() {
                this.isLoading = true;
                recordRepository.loadPaymentRequests(this.recordId)
                    .then(response => {
                        this.paymentRequestData = response.data.attributes;
                    }
                    )
                    .finally(() => {
                        this.isLoading = false;
                    });
            },
            reset() {
                this.isModalOpen = false;
            },
        },
    }

</script>
